import { CalendarProvider } from 'contexts/CalendarContext';
import CalendarLayout from 'layouts/CalendarLayout';

interface CalendarRouteProps {
  Component: React.ComponentType;
}

const CalendarRoute: React.FC<CalendarRouteProps> = ({ Component }) => {
  return (
    <CalendarProvider>
      <CalendarLayout>
        <Component />
      </CalendarLayout>
    </CalendarProvider>
  );
};

export default CalendarRoute;